import { render, staticRenderFns } from "./posted.vue?vue&type=template&id=4e3852b2&"
import script from "./posted.vue?vue&type=script&lang=js&"
export * from "./posted.vue?vue&type=script&lang=js&"
import style0 from "./posted.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports